import type { GetCourseReviewsSortOrder } from './getCourseReviewsSortOrder';

export type GetCourseReviewsParams = {
/**
 * 페이지 번호 (0부터 시작)
 */
page?: number;
/**
 * 페이지 크기
 */
size?: number;
/**
 * 정렬 기준 필드명
 */
sortBy?: string;
/**
 * 정렬 순서 (ASC 오름차순, DESC 내림차순)
 */
sortOrder?: GetCourseReviewsSortOrder;
};
